import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const TopicsInner = styled.div`
  padding: 18px 15px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  background-color: #fff;
  ${minMediaQueries.phone`
    padding: 24px;
  `};
  ${minMediaQueries.phablet`
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: ${({ theme }) => theme.boxShadow};
  `};
  ${maxMediaQueries.phablet`
    margin-left: -24px;
    margin-right: -24px;
  `};
  ${maxMediaQueries.phone`
    margin-left: -15px;
    margin-right: -15px;
  `};
`;
